// src/pages/TicketTrackingPage.js
import React, { useEffect, useState } from 'react';
import { getAdminTickets, updateTicketStatus } from '../api/api';
import styles from './TicketTrackingPage.module.css';

const TicketTrackingPage = () => {
    const [tickets, setTickets] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    // Chargement des données
    const fetchTickets = async () => {
        setLoading(true);
        try {
            const response = await getAdminTickets();
            // On suppose que le backend renvoie un tableau d'objets
            setTickets(response.data);
            setError(null);
        } catch (err) {
            console.error(err);
            setError("Impossible de charger les tickets. Vérifiez votre connexion ou vos droits d'accès.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTickets();
    }, []);

    // Gestion du changement de statut
    const handleStatusChange = async (ticketId, newStatus) => {
        // 1. Mise à jour optimiste (pour l'UI immédiate)
        const oldTickets = [...tickets];
        setTickets(tickets.map(t => 
            t.ticket_id === ticketId ? { ...t, status_ticket: newStatus } : t
        ));

        try {
            // 2. Appel API
            await updateTicketStatus(ticketId, newStatus);
        } catch (err) {
            // 3. Rollback en cas d'erreur
            console.error("Erreur update status", err);
            setTickets(oldTickets);
            alert("Erreur lors de la mise à jour du statut");
        }
    };

    // Fonction utilitaire pour formater la date
    const formatDate = (dateString) => {
        if (!dateString) return '-';
        return new Date(dateString).toLocaleDateString('fr-FR', {
            day: '2-digit', month: '2-digit', year: 'numeric',
            hour: '2-digit', minute: '2-digit'
        });
    };

    // Classe CSS dynamique pour le badge
    const getBadgeClass = (status) => {
        // Enlève les espaces et met en minuscule pour correspondre aux classes CSS
        // Ex: "Non traité" -> "statusNontraité"
        const normalized = status ? status.replace(/\s+/g, '') : 'Nontraité';
        return styles[`status${normalized}`] || styles.statusNontraité;
    };

    return (
        <div className={styles.container}>
            <div className={styles.card}>
                <div className={styles.header}>
                    <h1 className={styles.title}>🎫 Suivi des demandes Support</h1>
                    <button onClick={fetchTickets} className={styles.refreshBtn}>
                        🔄 Actualiser
                    </button>
                </div>

                {loading ? (
                    <div className={styles.loading}>Chargement des tickets...</div>
                ) : error ? (
                    <div className={styles.error}>{error}</div>
                ) : tickets.length === 0 ? (
                    <div className={styles.empty}>Aucun ticket trouvé.</div>
                ) : (
                    <table className={styles.table}>
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Date</th>
                                <th>Consultant</th>
                                <th>Type</th>
                                <th>Message</th>
                                <th>Statut Actuel</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {tickets.map((ticket) => (
                                <tr key={ticket.ticket_id}>
                                    <td>#{ticket.ticket_id}</td>
                                    <td>{formatDate(ticket.created_at)}</td>
                                    <td>
                                        <strong>{ticket.prenom} {ticket.nom}</strong>
                                    </td>
                                    <td>{ticket.ticket_type}</td>
                                    <td title={ticket.message_content}>
                                        <div className={styles.messagePreview}>
                                            {ticket.message_content}
                                        </div>
                                    </td>
                                    <td>
                                        <span className={`${styles.badge} ${getBadgeClass(ticket.status_ticket)}`}>
                                            {ticket.status_ticket}
                                        </span>
                                    </td>
                                    <td>
                                        <select 
                                            value={ticket.status_ticket} 
                                            onChange={(e) => handleStatusChange(ticket.ticket_id, e.target.value)}
                                            className={styles.statusSelect}
                                        >
                                            <option value="Non traité">Non traité</option>
                                            <option value="En cours">En cours</option>
                                            <option value="Traité">Traité</option>
                                        </select>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    );
};

export default TicketTrackingPage;